"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgAmenityValet = function SvgAmenityValet(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M664.8 37.7S405.4-93.6 306.1 133.8c-76.9 176.1-38.4 291.4 48 361.9l-48 121.7-28.8 12.8c-16 6.4-22.4 25.6-16 41.6l22.4 57.6-54.4 22.4c-19.2 6.4-25.6 25.6-19.2 41.6l22.4 57.6-54.5 22.5c-16 6.4-22.4 25.6-16 41.6l32 86.5c3.2 9.6 9.6 16 16 19.2 3.2 3.2 9.6 3.2 16 3.2l112.1-22.4c9.6-3.2 19.2-9.6 22.4-19.2L527 575.7c115.3 22.4 233.8-22.4 317-211.3C940.2 140.2 664.8 37.7 664.8 37.7zm-355.5 903l-67.2 12.8-12.8-32 54.4-22.4c16-6.4 22.4-25.6 16-41.6l-19.2-57.6 54.4-22.4c16-6.4 22.4-25.6 16-41.6l-22.4-57.6 12.8-6.4c6.4-3.2 12.8-9.6 16-19.2l51.2-128.1 57.6 25.6-156.8 390.5zm461.1-691.6c-6.4 16-25.6 25.6-44.8 16L450.2 146.6c-16-6.4-22.4-25.6-16-41.6 6.4-16 25.6-25.6 44.8-16l275.4 118.5c16 6.3 25.6 25.5 16 41.6z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgAmenityValet, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;